const PlanCard = ({
  plan,
  color = "black",
  setSelectedPlan,
  setOpen,
  offer,
  name,
  // setColor,
}) => {
  console.log("plan", plan);
  function onClick() {
    setSelectedPlan(plan);
    setOpen(true);
    // setColor("#F47920")
  }


  function getPlanPrice(){
    let secondPrices = offer?.useSecondPrice?.split("\n");
    console.log("secondPrices", secondPrices);
    console.log("plan.price", plan.speed);
    if (secondPrices?.length > 0) {
      let showSecondPrice = secondPrices?.find((item) => item.includes(plan.speed.toString())); 
      if(showSecondPrice && plan.secondPrice){
        return plan.secondPrice
      }
      else{
        return plan.price
      }
    }
    else {
      return plan.price;
    }
  }

  return (
    <div
      className={`rounded-3xl overflow-hidden border-[0.5rem] flex flex-col justify-around items-start gap-4 bg-white shadow-lg p-8`}
      style={{ minHeight: "500px", minWidth: "400px", borderColor: color }}
    >
      <p className="text-4xl text-black font-bold w-fit">{plan?.name}</p>
      {plan?.name.includes("Wi-Fi7") ? (
        <p className="text-2xl text-[#FF4500] font-bold">
          POWERED BY EERO MAX 7 <br /> Wi-Fi ROUTER
        </p>
      ) : (
        <p className="text-2xl text-[#FF4500] font-bold">
          Powered by eero Pro 6E <br /> Wi-Fi Router
        </p>
      )}
      <p className="text-2xl text-[#707070] font-semibold w-fit">
        {plan?.speed},000 MBPS UPLOAD & <br /> {plan?.speed},000 MBPS DOWNLOAD
      </p>
      <p className="text-5xl text-black font-bold w-fit">
        ${getPlanPrice()}
        <span className="text-4xl text-black font-bold">/mo</span>
      </p>
      <button
        onClick={() => onClick()}
        className="w-full mt-4 py-3 text-xl font-bold text-white rounded-lg bg-[#FB612F]"
      >
        ACCEPT OFFER
      </button>
    </div>
  );
};

export default PlanCard;
